import React from 'react';

import {EMPTY_DISPLAY} from '../utils/formatFrameworkFieldValue';
import {parseHtmlAnswerToReact} from '../utils/htmlAnswerToReact';

interface SidebarHtmlContentProps {
  html: string;
}

export const SidebarHtmlContent: React.FC<SidebarHtmlContentProps> = ({
  html
}) => {
  const trimmed = (html || '').trim();

  if (!trimmed) {
    return <span className="sidebar-html-content--empty">{EMPTY_DISPLAY}</span>;
  }

  const content = parseHtmlAnswerToReact(trimmed);

  if (!content) {
    return <span className="sidebar-html-content--empty">{EMPTY_DISPLAY}</span>;
  }

  return <div className="sidebar-html-content">{content}</div>;
};
